<cp-base-notification contentClassName="info" wrapperClassName="info">
  <ng-container header>
    <ui-svg-icon
      iconClassName="icon-notification--due-to-expire"
      svgId="timer-12"
    ></ui-svg-icon>
    <span>Your compliance is due to expire</span>
  </ng-container>
  <ng-container *ngIf="isNotCompliancePage" cta>
    <a
      class="compliance-due-to-expire-notification__cta__link"
      routerLink="/compliance"
      >Update Now<span
        class="compliance-due-to-expire-notification__cta__link__chevron"
      ></span
    ></a>
  </ng-container>
  <ng-container content>
    Your compliance is going to expire soon. Make sure you update it as soon as
    possible.
  </ng-container>
</cp-base-notification>
